import moment from 'moment';

// Horários que a API grava em Brasília (INTERNACIONALIZACAO_EUA_PLAN.md §2.5, tipo 2): updated_at, hora de
// cada status, itens da conta. Fora do Brasil eles são mostrados no fuso da loja (§4.8). O cardápio não tem
// moment-timezone; o Intl do navegador sabe as regras de cada fuso, inclusive o horário de verão.

export const FUSO_GRAVACAO = 'America/Sao_Paulo';

/** Quantos minutos o relógio do fuso está à frente do UTC naquele instante. */
const deslocamento = (instanteUtc, timeZone) => {
    const partes = new Intl.DateTimeFormat('en-US', {
        timeZone,
        hourCycle: 'h23',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).formatToParts(new Date(instanteUtc));

    const valor = tipo => +partes.find(p => p.type === tipo).value;
    const relogio = Date.UTC(valor('year'), valor('month') - 1, valor('day'), valor('hour'), valor('minute'), valor('second'));

    return (relogio - instanteUtc) / 60000;
};

/** "2026-10-22 18:00:00" de Brasília → moment com o horário de relógio do mesmo instante no fuso da loja. */
export const deBrasiliaPara = (dh, timeZone) => {
    const lido = moment(dh);
    const relogio = Date.UTC(lido.year(), lido.month(), lido.date(), lido.hours(), lido.minutes(), lido.seconds());

    let instante = relogio - deslocamento(relogio, FUSO_GRAVACAO) * 60000;
    instante = relogio - deslocamento(instante, FUSO_GRAVACAO) * 60000;

    const destino = new Date(instante + deslocamento(instante, timeZone) * 60000);

    return moment({
        year: destino.getUTCFullYear(),
        month: destino.getUTCMonth(),
        date: destino.getUTCDate(),
        hour: destino.getUTCHours(),
        minute: destino.getUTCMinutes(),
        second: destino.getUTCSeconds(),
    });
};
